import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'role_form';
export const useUserFormTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title_create: 'Новая роль',
    title_update: 'Изменить роль',
    name: 'Название',
    description: 'Описание',
    submit_create: 'Создать',
    submit_update: 'Сохранить',
    cancel: 'Отмена',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title_create: 'New Role',
    title_update: 'Change Role',
    name: 'Name',
    description: 'Description',
    submit_create: 'Create',
    submit_update: 'Save',
    cancel: 'Cancel',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title_create: 'Nova Função',
    title_update: 'Alterar Função',
    name: 'Nome',
    description: 'Descrição',
    submit_create: 'Criar',
    submit_update: 'Salvar',
    cancel: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title_create: 'Nuevo Rol',
    title_update: 'Cambiar Rol',
    name: 'Nombre',
    description: 'Descripción',
    submit_create: 'Crear',
    submit_update: 'Guardar',
    cancel: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;
